// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1uCUL","selects":"Documents_selects__22JgM"};